import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const AnimatedLetter = styled(motion.span)`
  display: inline-block;
  opacity: 0;
`;

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        telephone: '',
        company: '',
        message: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        // Gérer la soumission du formulaire ici
        console.log(formData);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Animation pour chaque lettre
    const letterAnimation = {
        hidden: {
            opacity: 0,
            x: 100 // Commence à droite
        },
        visible: (i) => ({
            opacity: 0.5,
            x: 0,
            transition: {
                delay: i * 0.2, // Délai progressif pour chaque lettre
                duration: 0.8,
                ease: "easeOut"
            }
        })
    };


    return (
        <Container>
            <ContentWrapper>
                {/* TITRE  */}
                <Title
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Restons connectés
                </Title>

                {/* CONTACT  */}
                <BackgroundText>
                    {"CONTACT".split('').map((letter, index) => (
                        <AnimatedLetter
                            key={index}
                            custom={index}
                            variants={letterAnimation}
                            initial="hidden"
                            animate="visible"
                        >
                            {letter}
                        </AnimatedLetter>
                    ))}
                </BackgroundText>

                {/* FORMULAIR  */}
                <ContactGrid>
                    <ContactInfo>
                        <div>
                            <h2>VOLTAUTO Belgique</h2>
                            <address>
                                rue de la vallée<br />
                                51 1000 bruxelles<br />
                                Belgique
                            </address>
                        </div>

                        <div>
                            <h2>VOLTAUTO France</h2>
                            <address>
                                Rue de Buci<br />
                                75006 Paris<br />
                                France
                            </address>
                        </div>

                        <div style={{ marginTop: "2rem" }}>
                            <a href="mailto:contact@voltauto.com">contact@voltauto.com</a>
                            <a href="tel:+33123456789">+32 1 39 78 05 41</a>
                        </div>
                    </ContactInfo>

                    <ContactForm
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        onSubmit={handleSubmit}
                    >
                        <FormHeader>
                            <h3>LAISSEZ-NOUS UN MESSAGE</h3>

                        </FormHeader>

                        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
                            <InputGroup>
                                <Input
                                    type="text"
                                    name="firstName"
                                    placeholder="Prénom"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                />
                            </InputGroup>
                            <InputGroup>
                                <Input
                                    type="text"
                                    name="lastName"
                                    placeholder="Nom"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                />
                            </InputGroup>
                        </div>

                        <InputGroup>
                            <Input
                                type="email"
                                name="email"
                                placeholder="Adresse email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </InputGroup>

                        <InputGroup>
                            <Input
                                type="tel"
                                name="telephone"
                                placeholder="Téléphone"
                                value={formData.telephone}
                                onChange={handleChange}
                            />
                        </InputGroup>

                        <InputGroup>
                            <Input
                                type="text"
                                name="company"
                                placeholder="Entreprise"
                                value={formData.company}
                                onChange={handleChange}
                            />
                        </InputGroup>

                        <InputGroup>
                            <TextArea
                                name="message"
                                placeholder="Message"
                                value={formData.message}
                                onChange={handleChange}
                            />
                        </InputGroup>

                        <SubmitButton type="submit">ENVOYER</SubmitButton>
                    </ContactForm>
                </ContactGrid>
            </ContentWrapper>
        </Container>
    );
};

export default Contact;


const Container = styled.div`
  min-height: 100vh;
  background: white;
  padding: 2rem;
`;

const ContentWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 10rem;

  @media (max-width: 768px) {
    padding-top: 5rem;
  }
`;

const Title = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 4rem;


  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 2rem;
      text-align: center;
  }
`;

const BackgroundText = styled.div`
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18vw;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  pointer-events: none;
  z-index: 1;
  user-select: none;
  text-transform: uppercase;
  letter-spacing: 1vw;
  opacity: 0.5;

  @media (max-width: 768px) {
    font-size: 10vw;
    letter-spacing: 0.5vw;
     color: rgba(0, 0, 0, 0.3);
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const ContactInfo = styled.div`
  h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  address {
    font-style: normal;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }

  a {
    color: black;
    text-decoration: none;
    display: block;
    margin-top: 0.5rem;
    
    &:hover {
      text-decoration: underline;
    }

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
`;

const ContactForm = styled(motion.form)`
  background: white;
  padding: 2rem;
  border: 1px solid rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const FormHeader = styled.div`
  margin-bottom: 2rem;

  h3 {
    font-size: 1.2rem;
    font-weight: 600;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
`;

const InputGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem 0;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-bottom-color: black;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.8rem 0;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  min-height: 100px;
  resize: vertical;

  &:focus {
    outline: none;
    border-bottom-color: black;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 1rem;
  background: black;
  color: white;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #333;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;
